import { default as TrainingNeedsAnalysis } from "./training_needs_analysis";
export default TrainingNeedsAnalysis 


// WEBPACK FOOTER //
// ./src/views/training_needs_analysis/index.js